export const portfolioKeys = {
    all: ["portfolio"] as const,
    chart: (wikifolioId: string) => ["portfolio", "chart", wikifolioId] as const,
    table: (fullName: string) => ["portfolio", "table", fullName] as const,
    distribution: (symbol: string) => ["portfolio", "distribution", symbol] as const,
    pnl: (symbol: string, beginMonth: string, endMonth: string) => ["portfolio", "pnl", symbol, beginMonth, endMonth] as const,
} as const;
